import { useDispatch } from "react-redux";

import { ReduxDispatch } from "../lib/state/store";

export const useAppDispatch: () => ReduxDispatch = useDispatch;
